export const RENEWALS_COLUMNS = {
  LEASE_NAME: 'leaseName',
  TERM: 'term',
  RENT: 'rent',
  PERCENT_CHANGE: 'percentChange',
  AMOUNT_CHANGE: 'amountChange',
  OTHER_CHARGES: 'otherCharges',
  NEW_TOTAL: 'newTotal',
  INCENTIVES: 'incentives',
}
